import { useEffect, useState } from "react";

import Paper from "@mui/material/Paper";

import AfterFooter from "../AfterFooter/AfterFooter";
import BeforeHeader from "../BeforeHeader/BeforeHeader";
import Contact from "../Contact/Contact";
import Feedbacks from "../Feedbacks/Feedbacks";
// import Footer from "../Footer/Footer";
import Gallery from "../Gallery/Gallery";
import Header from "../Header/Header";
import Highlights from "../Highlights/Highlights";
import Posts from "../Posts/Posts";
import Services from "../Services/Services";
import WhoWeAre from "../WhoWeAre/WhoWeAre";

import actions from "../../../data/actions";

const App = props => {
  const [initialized, setInitialized] = useState(false);

  // (init) -> initialized
  useEffect(() => {
    Promise.resolve()
      .then(() => actions.initialize())
      .then(() => setInitialized(true))
      .catch(error => console.log(error));
  }, []);

  return (
    <Paper elevation={0} square>
      {initialized && (
        <>
          <BeforeHeader />
          <Header />
          <Highlights />
          <Services />
          <WhoWeAre />
          <Posts />
          <Gallery />
          <Feedbacks />
          <Contact />
          <AfterFooter />
        </>
      )}
    </Paper>
  );
};

export default App;
